import {
  addDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase/config";

export const addItem = (items, customer) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_ITEM_START" });

    try {
      const totalPrice = (items || []).reduce(
        (sum, item) => sum + Number(item.price || 0) * Number(item.piece || 0),
        0
      );

      const docRef = await addDoc(collection(db, "orders"), {
        order_code: customer?.order_code || "",
        customer_name: customer?.name || "",
        email: customer?.email || "",
        phone: customer?.phone || "",
        address: customer?.address || "",
        city: customer?.city || "",
        note: customer?.note || "",
        status: "new",
        total_price: totalPrice,
        items: items || [],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      const response = { status: 200, data: { id: docRef.id } };
      dispatch({ type: "ADD_ITEM_SUCCESS", payload: response.data });
      return response;
    } catch (error) {
      dispatch({
        type: "ADD_ITEM_ERROR",
        payload: error?.message || "تعذر حفظ الطلب",
      });
      throw error;
    }
  };
};

export const addComments = (item) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_COMMENTS_START" });

    try {
      const docRef = await addDoc(collection(db, "comments"), {
        ...item,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      const response = { status: 200, data: { id: docRef.id } };
      dispatch({ type: "ADD_COMMENTS_SUCCESS", payload: response.data });
      return response;
    } catch (error) {
      dispatch({
        type: "ADD_COMMENTS_ERROR",
        payload: error?.message || "تعذر حفظ التعليق",
      });
      throw error;
    }
  };
};

export const addContact = (item) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_CONTACT_START" });

    try {
      const docRef = await addDoc(collection(db, "contacts"), {
        name: item?.name || "",
        email: item?.email || "",
        phone: item?.phone || "",
        subject: item?.subject || "",
        message: item?.message || "",
        status: "new",
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      const response = { status: 200, data: { id: docRef.id } };
      dispatch({ type: "ADD_CONTACT_SUCCESS", payload: response.data });
      return response;
    } catch (error) {
      dispatch({
        type: "ADD_CONTACT_ERROR",
        payload: error?.message || "تعذر إرسال الرسالة",
      });
      throw error;
    }
  };
};